module.exports = __webpack_public_path__ + "static/media/03_Lisa.4ba91bb7.png";